export default __webpack_public_path__ + "static/media/no-review.b9e90941.png";